import { search } from "fast-fuzzy";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  ArrowIcon,
  CheckBoxActiveIcon,
  CheckBoxInActiveIcon,
  CheckBoxSelectedAll,
  CloseIcon,
  SearchIcon
} from "../../Assets/assets";
import { isValidArray } from "../../Services/validators";

function CustomSelect(props) {
  const inputRef = useRef(null);
  const label = useRef(null);
  const [show, setShow] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!show) return;

    const handleClickOutside = (event) => {
      setTimeout(() => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setShow(false);
        }
      }, 0);
    };

    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [show]);

  const searchedData = useMemo(() => {
    if (!searchKey) {
      return props.options;
    }
    return search(searchKey, props.options, {
      keySelector: (item) => item.title,
      threshold: 0.7
    });
  }, [searchKey, props.options]);

  return (
    <div
      ref={dropdownRef}
      className="inherit-parent-width display-flex flex-align-items-center flex-direction-column position-relative"
    >
      <div
        data-cy={`${props["data-cy"]}-SELECT`}
        style={{
          height: "48px"
        }}
        onClick={() => {
          setShow(!show);
        }}
        className="inherit-parent-width position-relative position-relative display-flex flex-align-items-end input-box-border-bottom-default cursor-pointer margin-bottom-large"
      >
        <div
          style={{
            width: "95%"
          }}
        >
          <input
            data-cy={props["data-cy"]}
            readOnly={true}
            placeholder={props.placeholder}
            value={props.value || ""}
            className={`${props.className || " "}
              font-color-tertiaryColor calendar-icon-color-invert inherit-parent-width input-box background-transparent font-size-medium padding-top-large padding-bottom-default display-block input-box-disabled-padding-left-5px border-radius-0 border-none ${
                typeof props.buttonTile === "string"
                  ? "padding-right-4p7-em"
                  : ""
              } ${(props.type === "date" || props.type === "time") &&
              "padding-right-0"} ${
              props.disabled === true
                ? props.fontColor || " font-color-tertiaryColor6 disabled"
                : props.fontColor || " font-color-tertiaryColor6"
            }`}
            type="text"
          />

          <label
            htmlFor={props.name}
            ref={label}
            className={` ${
              props.removeResponsive ? "" : "adaptive-font-size"
            } ${props.labelFontColor ||
              "font-color-tertiaryColor6 "} active input-box-label position-absolute font-size-medium ${
              props.labelClassName ? props.labelClassName : ""
            } ${
              inputRef.current === document.activeElement ||
              props.value ||
              props.defaultValue ||
              (props.type === "number" && parseInt(props.value) > 0
                ? true
                : false) ||
              props.type === "time" ||
              props.type === "date" ||
              props.alwaysActive ||
              props.autoFocus === true
                ? "active"
                : ""
            } ${props.disabled ? " disabled " : ""}`}
          >
            {props.label}
          </label>
        </div>
        <div
          data-cy={`${props["data-cy"]}-SELECT-DROP-DOWN-ICON`}
          className={`position-absolute right-0 flex-align-items-center flex-justify-content-center min-width-1em absolute-center-self-vertically`}
        >
          <ArrowIcon color="var(--tertiaryColor6)" />
        </div>
      </div>
      {show && props.options && (
        <div
          style={{
            ...(props.options.length > 6
              ? {
                  height:
                    props.optionHeight || (props.search ? "260px" : "226px")
                }
              : { height: "fit-content" }),
            width: "100%",
            position: "absolute",
            top: "62px",
            zIndex: "1000"
          }}
          className="box-shadow-default background-color-tertiaryColor1 padding-top-large padding-left-medium padding-right-medium padding-bottom-medium"
          data-cy="OPTIONS-DROPDOWN"
        >
          {props.search && (
            <div
              style={{
                top: 0
              }}
              className="position-sticky"
            >
              <SearchOptions
                label={props.searchLabel || "Search"}
                onChange={(e) => {
                  setSearchKey(e.target.value);
                }}
                onCloseClick={() => {
                  setSearchKey("");
                }}
                searchKey={searchKey}
              />
            </div>
          )}
          {props.showSelectAll && (
            <div
              className="display-flex flex-align-items-center margin-bottom-default"
              onClick={props.selectAll}
              data-cy="SELECT-ALL-OPTIONS"
            >
              <div
                style={{
                  height: "16px"
                }}
              >
                {props.selected.length === props.options.length ? (
                  <CheckBoxSelectedAll />
                ) : (
                  <CheckBoxInActiveIcon color="var(--tertiaryColor6)" />
                )}
              </div>
              <div className=" font-color-tertiaryColor margin-left-default">
                Select all
              </div>
            </div>
          )}

          <div
            style={{
              height: `calc(100% - ${
                props.showSelectAll ? 64 : props.search ? 48 : 4
              }px)`
            }}
            className={`overflow-scroll inherit-parent-height inherit-parent-width ${props.showSelectAll &&
              "margin-left-larger"}`}
          >
            <div className="inherit-parent-height">
              {isValidArray(searchedData) &&
                searchedData?.map((data, i) => (
                  <div
                    data-cy={`${data?.title
                      ?.toString()
                      ?.toUpperCase()}-SELECT-FILTER-OPTION${
                      data.disabled ? "-DISABLED" : ""
                    }`}
                    key={i}
                    style={{
                      ...(data.disabled ? { opacity: 0.5 } : { opacity: 1 })
                    }}
                    className={`display-flex ${
                      i === 0 ? "" : "padding-top-default"
                    } flex-align-items-center`}
                    onClick={() => {
                      if (!data.disabled) {
                        props.handleSelectedData(data.key);
                      }
                    }}
                  >
                    <div
                      style={{
                        height: "16px",
                        width: "16px"
                      }}
                      className="margin-right-default display-flex flex-align-items-center"
                    >
                      {props.selected?.includes(data.key) ? (
                        <CheckBoxActiveIcon color="var(--secondaryColor)" />
                      ) : (
                        <CheckBoxInActiveIcon color="var(--tertiaryColor6)" />
                      )}
                    </div>
                    <div
                      style={{
                        width: "200px"
                      }}
                      className="white-space-nowrap font-color-tertiaryColor text-transform-capitalize text-overflow-ellipsis"
                    >
                      {data.title}
                    </div>
                  </div>
                ))}

              {!isValidArray(searchedData) && (
                <div className="inherit-parent-height flex-align-items-center flex-justify-content-center font-color-tertiaryColor6 font-size-medium">
                  NO SEARCH RESULTS FOUND
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomSelect;

const SearchOptions = (props) => {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
      }}
      style={{ height: 36 }}
      className={`inherit-parent-width margin-bottom-default`}
    >
      <div className="display-flex flex-justify-content-center flex-align-items-center">
        <input
          style={{
            width: "100%"
          }}
          className="font-color-tertiaryColor background-color-tertiaryColor1 inherit-parent-height margin-bottom-default border-none font-size-medium inherit-parent-width"
          value={props.searchKey}
          onChange={props.onChange}
          title={props.label}
          placeholder={props.label}
          data-cy="SELECT-SEARCH-FIELD"
        />

        <button
          className="padding-right-default background-color-transparent cursor-pointer"
          type="button"
          onClick={() => {
            if (props.searchKey) {
              props.onCloseClick();
            }
          }}
        >
          {!props.searchLoading && !props.searchKey ? (
            <SearchIcon color="var(--tertiaryColor6)" />
          ) : (
            <></>
          )}

          {!props.searchLoading && props.searchKey ? (
            <CloseIcon color="var(--tertiaryColor6)" width={16} height={16} />
          ) : (
            <></>
          )}

          {props.searchLoading ? (
            <div
              className="export-loader"
              style={{ height: "16px", width: "16px" }}
            />
          ) : (
            <></>
          )}
        </button>
      </div>
      <div
        style={{
          height: "2px",
          backgroundColor: props.searchKey ? "#FFFFFF" : "#3E3E3E"
        }}
        className="inherit-parent-width"
      />
    </form>
  );
};
